<div class="tu-dialog">

  <!-- Header -->
  <div class="tu-header">
    <div class="tu-title-wrap">
      <div class="tu-title-icon">
        <mat-icon>upload_file</mat-icon>
      </div>
      <div class="tu-title-text">
        <h2 id="template_upload_title" class="tu-title">Upload template</h2>
        <div class="tu-subtitle">Import a template from a CSV file</div>
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="tu-close" [disabled]="saveClicked" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <form id="uploadTemplate" class="tu-body" (ngSubmit)="upload()">

    <div class="tu-field">
      <label class="tu-label">CSV file <span class="tu-req">*</span></label>
      <label class="tu-file" [class.has-file]="fileToUpload != null">
        <input class="tu-file-input" type="file" id="file" accept=".csv" (change)="handleFileInput($event.target.files)">
        <mat-icon class="tu-file-icon">{{fileToUpload != null ? 'task' : 'upload_file'}}</mat-icon>
        <span class="tu-file-text">
          <span class="tu-file-name">{{fileToUpload != null ? fileToUpload.name : 'Select a file'}}</span>
          <span class="tu-file-hint">{{fileToUpload != null ? 'Click to choose a different file' : 'Click to browse for a .csv file'}}</span>
        </span>
      </label>
      <button type="button" class="tu-example" (click)="downloadExample()">
        <mat-icon>download</mat-icon>
        <span>Download example CSV</span>
      </button>
    </div>

    <div class="tu-field">
      <label class="tu-label">Template name <span class="tu-req">*</span></label>
      <mat-form-field appearance="outline" class="tu-mat full-width">
        <input matInput placeholder="Name this template" type="text" required name="templateName" [(ngModel)]="templateName">
      </mat-form-field>
    </div>

    <div class="tu-field tu-field-last">
      <label class="tu-label">Template type</label>
      <div class="tu-types">
        @for (type of templateTypes; track type.id) {
          <button type="button" class="tu-type"
            [class.on]="selectedTemplateType === type.id"
            (click)="selectedTemplateType = type.id">
            <mat-icon class="tu-type-icon">{{type.id === 'primary' ? 'local_florist' : 'account_tree'}}</mat-icon>
            <span class="tu-type-name">{{type.name | titlecase}}</span>
            <span class="tu-type-desc">
              {{type.id === 'primary' ? 'Full grow plan with phases, used to plan harvests' : 'Reusable task sequence for task groups'}}
            </span>
            <mat-icon class="tu-type-check">check_circle</mat-icon>
          </button>
        }
      </div>
    </div>

  </form>

  <!-- Footer -->
  <div class="tu-footer">
    <div class="tu-footer-actions">
      <button mat-button mat-dialog-close class="tu-btn-ghost" [disabled]="saveClicked">Cancel</button>
      <button id="template_upload_save" type="submit" form="uploadTemplate" class="tu-btn-primary" [disabled]="saveClicked">
        @if (saveClicked) {
          <mat-spinner diameter=20 strokeWidth=3></mat-spinner>
        } @else {
          <span>Upload template</span>
          <mat-icon>check</mat-icon>
        }
      </button>
    </div>
  </div>

</div>
